import { Option } from 'components/_inputs/_types/Option';
import safeJSONParser from 'utils/safeJSONParser/safeJSONParser';

const parseJsonToOptions = (data: string | object): Option[] => {
  const dataObj = safeJSONParser(data) as Record<string, string>;
  return Object.entries(dataObj).map(([value, label]) => ({ value, label }));
};

export default parseJsonToOptions;
